module.exports = __webpack_public_path__ + "img/boy_010027.a4befa16.png";